export interface Category {
  key: string;
  i18nKey: string;
  url: string;
  image: string;
}

export const mainSiteUrl = "https://kaspreadsheet.com";

export const categories: Category[] = [
  {
    key: "shoes",
    i18nKey: "categories.shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20crisp%20white%20low-top%20sneakers%20with%20soft%20mint%20green%20laces%20photographed%20at%20a%20slight%20three-quarter%20angle%20on%20a%20warm%20terracotta%20studio%20surface%2C%20gentle%20morning%20light%20from%20the%20left%2C%20clean%20minimal%20editorial%20e-commerce%20product%20photography%20with%20subtle%20soft%20shadows%2C%20airy%20fresh%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-shoes&orientation=squarish&nocache=true",
  },
  {
    key: "hoodies",
    i18nKey: "categories.hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20neatly%20folded%20sage%20green%20hoodie%20sweatshirt%20resting%20on%20a%20light%20oatmeal%20linen%20background%20with%20a%20small%20sprig%20of%20dried%20eucalyptus%20beside%20it%2C%20soft%20diffused%20natural%20light%2C%20minimal%20editorial%20e-commerce%20product%20photography%2C%20calm%20fresh%20composition%20with%20gentle%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-hoodies&orientation=squarish&nocache=true",
  },
  {
    key: "tshirts",
    i18nKey: "categories.tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20stack%20of%20three%20folded%20t-shirts%20in%20blush%20pink%2C%20cream%20and%20soft%20mustard%20tones%20arranged%20neatly%20on%20a%20pale%20stone%20surface%2C%20soft%20window%20light%2C%20minimal%20editorial%20e-commerce%20product%20photography%2C%20fresh%20airy%20composition%20with%20gentle%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-tshirts&orientation=squarish&nocache=true",
  },
  {
    key: "jackets",
    i18nKey: "categories.jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20camel-colored%20lightweight%20jacket%20draped%20over%20the%20back%20of%20a%20light%20wooden%20chair%20against%20a%20soft%20sage%20green%20wall%2C%20warm%20afternoon%20light%2C%20minimal%20editorial%20e-commerce%20product%20photography%2C%20fresh%20cozy%20composition%20with%20soft%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-jackets&orientation=squarish&nocache=true",
  },
  {
    key: "pants",
    i18nKey: "categories.pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20neatly%20folded%20olive%20green%20chino%20pants%20with%20a%20matching%20pair%20of%20shorts%20laid%20flat%20on%20a%20warm%20sand-colored%20linen%20background%2C%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20clean%20fresh%20composition%20with%20gentle%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-pants&orientation=squarish&nocache=true",
  },
  {
    key: "headwear",
    i18nKey: "categories.headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimalist%20cream%20baseball%20cap%20resting%20on%20a%20light%20terracotta%20pottery%20surface%20with%20a%20soft%20peach%20backdrop%2C%20gentle%20natural%20light%2C%20minimal%20editorial%20e-commerce%20product%20photography%2C%20airy%20fresh%20composition%20with%20soft%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-headwear&orientation=squarish&nocache=true",
  },
  {
    key: "sets",
    i18nKey: "categories.sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20coordinated%20two-piece%20matching%20outfit%20set%20in%20warm%20beige%20and%20soft%20rust%20tones%20laid%20flat%20on%20a%20pale%20ivory%20background%20with%20a%20small%20caramel%20leather%20bag%20as%20an%20accent%2C%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20fresh%20composition%20with%20gentle%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-sets&orientation=squarish&nocache=true",
  },
  {
    key: "underwear",
    i18nKey: "categories.underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20set%20of%20neatly%20folded%20soft%20cotton%20underwear%20in%20muted%20gray%20and%20ivory%20tones%20on%20a%20clean%20stone-colored%20surface%20with%20a%20small%20linen%20pouch%20beside%20them%2C%20soft%20diffused%20light%2C%20minimal%20editorial%20product%20photography%2C%20calm%20fresh%20composition%20with%20gentle%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-underwear&orientation=squarish&nocache=true",
  },
  {
    key: "jersey",
    i18nKey: "categories.jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20folded%20athletic%20jersey%20in%20deep%20forest%20green%20with%20minimal%20white%20trim%20on%20a%20warm%20sand%20studio%20surface%2C%20soft%20natural%20window%20light%2C%20minimal%20editorial%20e-commerce%20product%20photography%2C%20fresh%20airy%20composition%20with%20soft%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-jersey&orientation=squarish&nocache=true",
  },
  {
    key: "accessories",
    i18nKey: "categories.accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimal%20flat%20lay%20of%20a%20brown%20leather%20watch%2C%20tortoiseshell%20sunglasses%20and%20a%20simple%20metal%20keychain%20arranged%20on%20a%20soft%20blush%20pink%20background%2C%20natural%20diffused%20light%2C%20minimal%20editorial%20e-commerce%20product%20photography%2C%20fresh%20composition%20with%20gentle%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-accessories&orientation=squarish&nocache=true",
  },
  {
    key: "bags",
    i18nKey: "categories.bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20clean%20natural%20canvas%20tote%20bag%20and%20a%20small%20caramel%20leather%20crossbody%20bag%20leaning%20together%20against%20a%20soft%20sage%20green%20wall%2C%20warm%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20fresh%20airy%20composition%20with%20soft%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-bags&orientation=squarish&nocache=true",
  },
  {
    key: "belts",
    i18nKey: "categories.belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20coiled%20chestnut%20brown%20leather%20belt%20with%20a%20brushed%20brass%20buckle%20resting%20on%20a%20light%20stone%20surface%20beside%20a%20small%20folded%20pair%20of%20jeans%2C%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20fresh%20composition%20with%20gentle%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-belts&orientation=squarish&nocache=true",
  },
  {
    key: "perfumes",
    i18nKey: "categories.perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20single%20amber%20glass%20perfume%20bottle%20with%20a%20minimal%20wooden%20cap%20on%20a%20warm%20ivory%20background%20with%20a%20sprig%20of%20dried%20lavender%20beside%20it%2C%20soft%20window%20light%2C%20minimal%20editorial%20product%20photography%2C%20fresh%20airy%20composition%20with%20gentle%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-perfumes&orientation=squarish&nocache=true",
  },
  {
    key: "other",
    i18nKey: "categories.other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimal%20arrangement%20of%20miscellaneous%20lifestyle%20items%20including%20a%20linen%20notebook%2C%20a%20soy%20candle%20in%20a%20glass%20jar%20and%20a%20small%20wooden%20tray%20on%20a%20warm%20sand%20background%2C%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20fresh%20composition%20with%20gentle%20shadows%2C%20high%20detail%2C%20no%20text&width=600&height=600&seq=cat-other&orientation=squarish&nocache=true",
  },
];